(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-carousel"] && !Shopify.designMode) return;
  try {
    
  function initSwiper(container) {
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }
    const slides = container.querySelectorAll('.collection-carousel__slide');
    const slideWrapper = container.querySelector('.collection-carousel__slides');
    if (slides.length < 5) {
      slideWrapper.classList.add('centered-slides');
    } else {
      slideWrapper.classList.remove('centered-slides');
    }
    new Swiper(container, {
      slidesPerView: 5,
      spaceBetween: 20,
      autoplay: false,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        1024: { slidesPerView: 5, spaceBetween: 20 },
        768: { slidesPerView: 3, spaceBetween: 20 },
        480: { slidesPerView: 2, spaceBetween: 15 },
        320: { slidesPerView: 1, spaceBetween: 15 },
      },
    });
  }
  document.querySelectorAll('.collection-list-carousel__wrapper').forEach(function (el) {
    initSwiper(el);
  });
  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target.querySelector('.collection-list-carousel__wrapper');
    if (container) initSwiper(container);
  });

  document.addEventListener('shopify:section:select', function (event) {
    const container = event.target.querySelector('.collection-list-carousel__wrapper');
    if (container) initSwiper(container);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
      
  (function () {
    'use strict';

    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab',
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab',
    };

    var isTransitioning = false;

    function init(scope) {
      var el = scope || document;
      var triggers = el.querySelectorAll(selectors.trigger);
      triggers.forEach(function (trigger) {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
        trigger.removeEventListener('click', toggle);
        trigger.addEventListener('click', toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) return;
      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls') || el.dataset.controls;

      if (!moduleId) {
        isTransitioning = false;
        return;
      }

      var container = document.getElementById(moduleId);

      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var inner = container.querySelector(selectors.moduleInner);
      if (!inner) {
        isTransitioning = false;
        return;
      }

      var height = inner.offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]').forEach(function (tab) {
          tab.classList.remove(classes.open);
          newModule = document.querySelector('#' + tab.getAttribute('aria-controls'));
          if (newModule) setTransitionHeight(newModule, 0, true);
        });
      }

      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          setTransitionHeight(container, 0, isOpen, isAutoHeight);
        }, 0);
      } else {
        if (isOpen && !isAutoHeight) {
          height = 0;
        }
        setTransitionHeight(container, height, isOpen, isAutoHeight);
      }

      el.setAttribute('aria-expanded', !isOpen);
      el.classList.toggle(classes.open, !isOpen);

      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;

        if (isOpen && parentHeight === 'auto') {
          childHeight = 0;
        }

        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }

      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (btn) {
          btn.removeEventListener('click', handleSprClick);
          btn.addEventListener('click', handleSprClick);
        }

        function handleSprClick() {
          var newHeight = inner.offsetHeight;
          setTransitionHeight(container, newHeight, false, isAutoHeight);
        }
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);

      var transitionCallback = function () {
        container.style.height = height + 'px';
        container.classList.toggle(classes.open, !isOpen);
      };

      if (window.theme && window.theme.utils && typeof window.theme.utils.prepareTransition === 'function') {
        window.theme.utils.prepareTransition(container, transitionCallback);
      } else {
        transitionCallback();
      }

      if (!isOpen && isAutoHeight) {
        window.setTimeout(function () {
          container.style.height = 'auto';
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    // Initialize on load and when sections are loaded in the editor
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
